export interface CloudFrontCredentials {
  path: string
  policy: string
  signature: string
  key_pair_id: string
  expires_at: number
}

export const applyCloudFrontCookies = (
  credentials: CloudFrontCredentials
): boolean => {
  const remaining =
    credentials.expires_at - Math.floor(Date.now() / 1000)

  if (remaining <= 0) return false

  // Validate that the path is an expected HLS video directory.
  if (
    !/^\/media\/users\/[A-Za-z0-9]+\/videos\/hls\/[A-Za-z0-9-]+\/$/.test(
      credentials.path
    )
  ) {
    console.error('[CloudFront] Invalid cookie path')
    return false
  }

  const attributes = [
    `Path=${credentials.path}`,
    'Domain=.allfans.com',
    'Secure',
    'SameSite=Lax',
    `Max-Age=${remaining}`
  ].join('; ')

  document.cookie =
    `CloudFront-Policy=${credentials.policy}; ${attributes}`

  document.cookie =
    `CloudFront-Signature=${credentials.signature}; ${attributes}`

  document.cookie =
    `CloudFront-Key-Pair-Id=${credentials.key_pair_id}; ${attributes}`

  return true
}